<form [formGroup]="form" class="flex-column">
  @if (pieceCycles) {
    <mat-form-field class="full-width">
      <mat-label>{{ 'UTILITIES.TOOL.SETUP.WAIVE_CYCLES' | bmsTranslate }}</mat-label>
      <input matInput type="number" vdwL10nDecimal formControlName="waiveCycles" placeholder="0" />
      <button *ngIf="form.controls?.waiveCycles?.value !== null" class="clear-input-button" tabindex="-1" mat-icon-button (click)="form.controls?.waiveCycles.reset()">
        <mat-icon svgIcon="solid-close" class="icon-12"></mat-icon>
      </button>
      <mat-error *vdwCanShowErrorForFormControl="'waiveCycles'; error: 'multiple'">
        <vdw-invalid-form-message [message]="'GENERAL.ERRORS.MULTIPLE_VALUE' | bmsTranslate: {value: pieceCycles}" [compact]="true"></vdw-invalid-form-message>
      </mat-error>
    </mat-form-field>
  }
  <div class="flex-row gap-16">
    <mat-form-field class="full-width">
      <mat-label>{{ 'UTILITIES.TOOL.SETUP.MOUNT_TIME' | bmsTranslate }}</mat-label>
      <input matInput type="number" vdwL10nDecimal min="0" formControlName="mountTime" placeholder="0" />
      <button *ngIf="form.controls?.mountTime?.value !== null" class="clear-input-button" tabindex="-1" mat-icon-button type="button" (click)="form.controls?.mountTime.reset()">
        <mat-icon svgIcon="solid-close" class="icon-12"></mat-icon>
      </button>
      <span matSuffix>
        {{ 'GENERAL.UNIT.MINUTE' | bmsTranslate }}
      </span>
      <mat-error *vdwCanShowErrorForFormControl="'mountTime'; error: 'min'">
        <vdw-invalid-form-message [message]="'GENERAL.ERRORS.MIN_VALUE' | bmsTranslate: {min: 0}" [compact]="true"></vdw-invalid-form-message>
      </mat-error>
    </mat-form-field>
    <mat-form-field class="full-width">
      <mat-label>{{ 'UTILITIES.TOOL.SETUP.DISMOUNT_TIME' | bmsTranslate }}</mat-label>
      <input matInput type="number" vdwL10nDecimal min="0" formControlName="dismountTime" placeholder="0" />
      <button *ngIf="form.controls?.dismountTime?.value !== null" class="clear-input-button" tabindex="-1" mat-icon-button type="button" (click)="form.controls?.dismountTime.reset()">
        <mat-icon svgIcon="solid-close" class="icon-12"></mat-icon>
      </button>
      <span matSuffix>
        {{ 'GENERAL.UNIT.MINUTE' | bmsTranslate }}
      </span>
      <mat-error *vdwCanShowErrorForFormControl="'dismountTime'; error: 'min'">
        <vdw-invalid-form-message [message]="'GENERAL.ERRORS.MIN_VALUE' | bmsTranslate: {min: 0}" [compact]="true"></vdw-invalid-form-message>
      </mat-error>
    </mat-form-field>
  </div>
</form>
